<div class="wrap">
  <h1>Timeline</h1>

  <div class="flex">
    <form
      class="camera_select"
      [formGroup]="choiceDateForm"
      (ngSubmit)="onSubmit(false)"
    >
      <mat-form-field appearance="outline">
        <mat-label>Camera </mat-label>
        <mat-select formControlName="camera">
          <mat-option [value]="c.id" *ngFor="let c of camera"
            >{{ c.name }}({{ c.externalId }})</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" />
        <mat-datepicker-toggle matSuffix [for]="picker">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Hour</mat-label>
        <mat-select
          formControlName="hours"
          multiple
          (selectionChange)="onChange()"
        >
          <mat-option
            *ngFor="let h of hours; let element; let i = index"
            [value]="i"
          >
            {{ i + "h" }}
          </mat-option>
        </mat-select>
        <mat-error>You have to select 2 hours max.</mat-error>
      </mat-form-field>
      <button
        class="btn"
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="choiceDateForm.invalid"
      >
        <fa-icon [icon]="faSearch"></fa-icon>
      </button>
    </form>

    <div class="upsideImage">
      <h6>
        <ng-container *ngIf="medias?.length > 0; else noMedia">
          Click on the image to request the video
        </ng-container>
        <ng-template #noMedia>
          Select a camera, a date and one or two hour(s) to see the timeline.
        </ng-template>
      </h6>
      <div class="actionsButtons">
        <button (click)="refresh()" mat-raised-button color="primary">
          Refresh
        </button>
        <button (click)="delete()" mat-raised-button color="primary">
          <fa-icon class="delete" [icon]="faTrash"></fa-icon> Delete selection
        </button>
      </div>
    </div>
    <div class="infos">
      <div
        [ngClass]="
          medias?.length === 0 ? 'carousel displayBlock' : 'carousel extend'
        "
        class="flex-horiz"
      >
        <mat-carousel
          [hidden]="medias?.length === 0 || isLoadingCarousel"
          timings="250ms ease-in"
          [autoplay]="false"
          interval="8000"
          color="primary"
          maxWidth="auto"
          maxHeight="100%"
          proportion="35"
          slides="5"
          [loop]="true"
          [hideArrows]="false"
          [hideIndicators]="false"
          [useKeyboard]="true"
          [useMouseWheel]="false"
          orientation="ltr"
        >
          <mat-carousel-slide
            #matCarouselSlide
            *ngFor="let t of medias"
            overlayColor="#FFFFFF"
            [hideOverlay]="false"
          >
            <app-image-preview [id]="t.id" [date]="t.externalId">
            </app-image-preview>
          </mat-carousel-slide>
        </mat-carousel>
        <mat-spinner
          *ngIf="isLoadingCarousel"
          [diameter]="50"
          color="primary"
        ></mat-spinner>
        <div>
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortActive="date"
            matSortDisableClear
          >
            <ng-container matColumnDef="date">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="cell_label"
                [style.text-align]="'center'"
              >
                Date of demand
              </th>
              <td mat-cell *matCellDef="let element" class="cell_label">
                {{ element?.uploadSession?.startedOn | date : "short" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="cell_label"
                [style.text-align]="'center'"
              >
                Video date
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="cell_label dateHours"
              >
                {{ getVideoName(element) }}
              </td>
            </ng-container>
            <ng-container matColumnDef="progression">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="cell_label"
                [style.text-align]="'center'"
              >
                Progression
              </th>
              <td mat-cell *matCellDef="let element" class="cell_label">
                <!-- {{element?.uploadSession?.uploadedChunks}}/{{element?.uploadSession?.totalChunks}}  -->

                {{ getPourcentagePackage(element) || 0 }}%
              </td>
            </ng-container>
            <ng-container matColumnDef="video">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="cell_action"
                [style.text-align]="'center'"
              >
                Video
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="cell_action"
              >
                <fa-icon
                  class="video"
                  [icon]="falink"
                  (click)="openDialogInfoCamera(element, i)"
                  matTooltip="show media"
                >
                </fa-icon>
              </td>
            </ng-container>

            <ng-container matColumnDef="delete">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="cell_action"
                [style.text-align]="'center'"
              >
                Delete
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="cell_action"
              >
                <mat-checkbox
                  id="{{ element.id }}"
                  (change)="checkboxChanger($event)"
                  color="primary"
                ></mat-checkbox>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <mat-paginator
            [length]="length"
            [pageSize]="pageSize"
            aria-label="Select page"
            [hidePageSize]="true"
          >
          </mat-paginator>
          <!-- <fa-icon class="delete"  (click)="delete()" [icon]="faTrash"></fa-icon> -->
        </div>
      </div>
    </div>
  </div>
</div>
